import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query"
import axios from "axios";
import { apiRoot } from "..";

const PasswordForgotten = () => {
  const navigate = useNavigate();

  const [inputs, setInputs] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const passwordResetRequestMutation = useMutation((passwordResetRequestData) => {
    return axios.post(apiRoot + '/user-reset-tokens', passwordResetRequestData);
  },
  {
    onSuccess: (response) => {
      console.log(response); // TODO
      // const jwtToken = response.data.token;
      // window.sessionStorage.setItem('jwtToken', jwtToken);
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken; // TODO
      // setUser(getUserFromDbUser(response.data.user));
      navigate("/");
    },
    onError: (error) => {
      setErrorMessage(error.message); // TODO json -> errorCode -> hlaska
      window.scrollTo(0, 0);
    }
  });

  const handleChange = (event) => {
    if (!passwordResetRequestMutation.isLoading) {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage(null);

    if (!inputs.mail) { // TODO trim
      setErrorMessage('Některé povinné položky nejsou vyplněné.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    passwordResetRequestMutation.mutate(inputs);
  }

  return (
    <>
<div className="login-wrapper">
<div className="login">
<form onSubmit={handleSubmit}>
<table border="0" cellSpacing="0">
  <tbody>
    <tr>
      <td align="center">{errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}</td>
    </tr>
    <tr>
      <td align="center"><img src="img/padlock.png" alt="Žádost o reset hesla" width="64" height="64" /></td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td align="center"><strong>Přihlašovací jméno (e-mail):</strong></td>
    </tr>
    <tr>
      <td align="center"><input type="text" className="form-control" name="mail" value={inputs.mail || ""} onChange={handleChange} /></td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td align="center"><button type="submit" className="btn btn-primary">Chci resetovat heslo</button></td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td align="center">Pokud zadaná e-mailová adresa odpovídá uživateli portálu,<br /> bude na ni odeslán e-mail s instrukcemi pro reset hesla.</td>
    </tr>
  </tbody>
</table>

</form>
</div>
</div>

<div className="login-image">
&nbsp;
</div>
    </>
  );
};

export default PasswordForgotten;